export const boShowImageExtensions = ["jpg", "jpeg", "jfif", "JFIF", "png", "JPG", "JPEG", "PNG", "gif", "bmp", "webp", "image/webp", "svg", "image/png","image/jpeg"];

export const isBoImageExtension = (extension = "") => {
    return boShowImageExtensions.includes(String(extension).toLowerCase());
};

export const formatCnpjToView = (cnpj) => {
    if (!cnpj) return "";

    return String(cnpj).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
};

export const getIndividualLabel = (individualList = [], itemId) => {
    if (!itemId) return "";

    const individual = individualList.find((item) => item.itemId === itemId);

    if (!individual) return "";

    return `${individual.itemId} - ${individual.name ?? "Indivíduo"}`;
};
